// Registra cada clique em botao/link no log dedicado do nginx (location /t/cta).
// Sem dado pessoal: o visitante e um id aleatorio do navegador, o IP nao entra no log.
// Rotulo do botao: data-cta, senao aria-label, senao o texto visivel.

const ENDPOINT = "/t/cta"
const CLICAVEL = "[data-cta],a,button,[role='button'],input[type='submit']"
let iniciado = false

function lerStorage(storage: Storage, chave: string, gerar: () => string): string {
  try {
    let valor = storage.getItem(chave)
    if (!valor) {
      valor = gerar()
      storage.setItem(chave, valor)
    }
    return valor
  } catch {
    return gerar()
  }
}

function novoId(): string {
  return typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

// Campanha e canal chegam na URL de entrada; guardados para os cliques das telas seguintes.
// Ha link da TIM malformado com os parametros no caminho (/campaign=&canal=TIMStore...).
function origemDaVisita(): { canal: string; campaign: string } {
  const bruto = lerStorage(sessionStorage, "ksk_cta_origem", () => {
    const texto = `${location.search}&${location.pathname.replace(/^\//, "")}`
    const p = new URLSearchParams(texto.replace(/^\?/, ""))
    return JSON.stringify({ canal: p.get("canal") || "", campaign: p.get("campaign") || p.get("utm_campaign") || "" })
  })
  try {
    return JSON.parse(bruto)
  } catch {
    return { canal: "", campaign: "" }
  }
}

export function rotuloDoClique(el: Element): string {
  // Botão só com ícone (a seta de enviar dos formulários) não tem texto: o nome vem do campo que ele envia.
  const campo = el.closest("form")?.querySelector("input,select,textarea")
  const texto =
    el.getAttribute("data-cta") ||
    el.getAttribute("aria-label") ||
    ((el as HTMLElement).innerText || el.textContent || "").trim() ||
    (el as HTMLInputElement).value ||
    el.getAttribute("title") ||
    el.getAttribute("alt") ||
    el.querySelector("img[alt]")?.getAttribute("alt") ||
    (campo ? `Enviar: ${campo.getAttribute("placeholder") || campo.getAttribute("name") || "campo"}` : "")
  // 4+ dígitos seguidos viram #: rótulo vindo de texto que não controlamos não pode carregar CPF, telefone ou CEP.
  return texto.replace(/\d{4,}/g, "#").replace(/\s+/g, " ").trim().slice(0, 80)
}

export function iniciarRastreioCta(): void {
  if (typeof window === "undefined" || iniciado) return
  iniciado = true
  const visitante = lerStorage(localStorage, "ksk_cta_vid", novoId)
  const origem = origemDaVisita()

  document.addEventListener(
    "click",
    (evento: MouseEvent) => {
      const el = evento.target instanceof Element ? evento.target.closest(CLICAVEL) : null
      if (!el) return
      const params = new URLSearchParams({
        cta: rotuloDoClique(el) || "(sem rotulo)",
        destino: ((el.getAttribute("href") || "").split(/[?#]/)[0] ?? "").slice(0, 200),
        pagina: location.pathname.slice(0, 120),
        canal: origem.canal,
        campaign: origem.campaign,
        vid: visitante,
      })
      const url = `${ENDPOINT}?${params}`
      // sendBeacon sobrevive a navegacao (link que troca de pagina); fetch keepalive e o reserva.
      if (!(navigator.sendBeacon && navigator.sendBeacon(url))) {
        fetch(url, { method: "POST", keepalive: true }).catch(() => {})
      }
    },
    true,
  )
}
